export default __webpack_public_path__ + "static/media/aboutimage.2755a2de.png";